// extracted by mini-css-extract-plugin
module.exports = {"page":"_app_page__Gp31t","logo":"_app_logo__VDF3d","scrollBar":"_app_scrollBar__Q_HdA"};